import React from 'react'
import { path } from 'ramda'
import { useSelector } from 'react-redux'

import { ChevronLeft } from '@/components/icons'

interface BackBtnProps {}

const BackBtn: React.FC<BackBtnProps> = () => {
  const building = useSelector(path(['listing', 'building']))

  const backToRentalListings = () => {
    const citySlug =
      building && typeof building === 'object' && 'city' in building
        ? String(building.city).toLowerCase()
        : undefined

    if (citySlug) {
      const backUrl = `/rental-listings/city/${citySlug}`
      window.location.href = backUrl
    } else {
      window.location.href = '/rental-listings' // don't expect to hit
    }
  }

  const handleBack = () => {
    if (document.referrer.includes('/rental-listings')) {
      if (document.referrer.includes('/rental-listings/detail')) {
        // edge case for detail listing page to open another detail listing page from simliar listing section
        backToRentalListings()
        return
      }
      window.close()
    } else {
      backToRentalListings()
    }
  }

  return (
    <button
      onClick={handleBack}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer'
      }}
      aria-label="Go back"
    >
      <ChevronLeft width={24} height={24} />
    </button>
  )
}

export default BackBtn
